import {Component, effect, inject, input, signal} from '@angular/core';
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";
import {FixedSamplePoint, SynchronizationStatus} from "src/app/infrastructure/moovement-api/models/asset";
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {isEqualToOrYoungerThanOffset} from 'src/app/app.config';
import {oneHour} from 'src/app/presentation/common/globals';
import {Router} from '@angular/router';
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';

@Component({
  selector: 'app-proximity-sample-point-button',
  imports: [
    BluetoothSvgComponent
  ],
  templateUrl: './proximity-sample-point-button.component.html',
  styleUrl: './proximity-sample-point-button.component.css'
})
export class ProximitySamplePointButtonComponent {

  id = input.required<string>();

  proximitySamplePoint = signal<FixedSamplePoint | undefined>(undefined);
  status = signal<Status>(Status.OFFLINE);
  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');

  SynchronizationStatus = SynchronizationStatus;

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private fixedSamplePointsStore = inject(FixedSamplePointsStore);
  private router = inject(Router);

  constructor() {
    effect(() => {
      const id = this.id();
      const loading = this.fixedSamplePointsStore.loading();
      if (!id || loading) return;

      this.proximitySamplePoint.set(this.fixedSamplePointsStore.entityMap()[id]);
    });

    effect(() => {
      const aggregatedState = this.aggregatedAssetStateStore.entityMap()[this.id()];
      if (!aggregatedState) return;

      const lastSeenByGatewayAt = aggregatedState.lastSeenByGatewayAt;
      this.statusMessage.set(`Last seen: ${timeAgo(lastSeenByGatewayAt)}`);
      const isSeenWithinThreshold = lastSeenByGatewayAt !== undefined && isEqualToOrYoungerThanOffset(lastSeenByGatewayAt, oneHour);
      if (isSeenWithinThreshold) {
        this.statusMessageColorClass.set("color-primary-information");
        this.status.set(Status.ONLINE);
      } else {
        this.statusMessageColorClass.set("color-danger");
        this.status.set(Status.OFFLINE);
      }
    });
  }

  focus() {
    this.router.navigate(['/main/proximity-sample-point-details', this.id()]);
  }
}
